import classNames from 'classnames'
import { Address } from 'types/common'
import { TimeDisplay } from './time-display'
import { PlaceDisplay } from './place-display'

export interface TimePlaceDisplayProps {
  dayClassName?: string
  venueClassName?: string
  timeClassName?: string
  className?: string
  dateTime: string
  timezone?: string
  place: string
  address?: Address
}

export function TimePlaceDisplay(props: TimePlaceDisplayProps) {
  const { dateTime, place, address, dayClassName, venueClassName, timeClassName, className } = props

  return (
    <div className={classNames(className, 'flex flex-col justify-end space-y-0.5')}>
      <TimeDisplay
        dayClassName={dayClassName}
        timeClassName={timeClassName}
        dateTime={dateTime}
        timezone={props.timezone}
      />
      {address && place && (
        <PlaceDisplay className={venueClassName} place={place} address={address} />
      )}
    </div>
  )
}
